(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

function isValidEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

$(window).resize(function(){
    //equalheight('.footer-media .inner');
});

$(window).load(function() {
    var top = $('.masthead').height() * 2 + 413 + $('.breadcrumbs').height() + 25;

    /**
     $('.booknow_sidebar').affix({
        offset: {
            top: top,
            bottom: $('.footer').height() - 50
        }
    });


     * Stretch the navigation to the full site width

     $('.full-width').horizontalNav({
        tableDisplay: false
    });

     equalheight('.footer-media .inner');
     */
});

equalheight = function(container){

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $(container).each(function() {

        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

$(function($) {
    'use strict';

    /**
     * Open external links in another tab (or window)
     * <a rel='external' ... > ... </a>
     *
     */
    $('a[rel*=external]').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        var $button = $(this),
            href = $button.attr('href'),
            noProtocol = href.replace(/http[s]?:\/\//, '');

        // check if Google Analytics tracking code is loaded and initialized
        if (typeof ga === 'function') {

            // track Google Analytics event
            ga('send', 'event', 'external', 'click', noProtocol, '', {
                'nonInteraction': true
            });
        }

        // open new tab/window for the clicked link
        window.open(href);
    });


    /**
     * Setup scroll to top behaviour
     */
    $('.go_top a').on('click', function(event) {
        event.preventDefault();
        $('body,html').animate({
            scrollTop: 0
        }, 1800);
        return false;
    });


    $(document)
        .on('mouseenter', '.hoverable > li', function() {
            $(this).addClass("hover");
        })
        .on('mouseleave', '.hoverable > li', function() {
            $(this).removeClass("hover");
        })
        .on('click', '.hoverable > li', function(event) {
            event.preventDefault();
            var $a = $(this).find("a");
            var href = $a.attr('href');
            if (href) {
                // open in same tab (window)
                window.location.href = href;
            }
        });


    if (typeof $.fn.magnificPopup == "function") {
        var magnificOptions = {
            type: 'image',
            mainClass: 'mfp-with-zoom',
            image: {
                titleSrc: function(item) {
                    return item.el.find('img').attr('alt');
                }
            },
            gallery: {
                enabled: true,
                preload: [0,2],
                navigateByImgClick: true
            },
            zoom: {
                enabled: true,
                duration: 300,
                easing: 'ease-in-out'
            }
        };

        $('.gallery-images a').magnificPopup(magnificOptions);
    }
});
